import React, { useEffect, useState, useCallback } from "react";
import AddIcon from "@mui/icons-material/Add";
import { Link, useLocation, useParams } from "react-router-dom";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import SwapVertIcon from '@mui/icons-material/SwapVert';
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { projectServices } from "../../services/projectServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import _ from "lodash";
import { getSecPermission,trimString } from "../../constant";
import Filter from "../filter/filter";
import Tooltip from '@mui/material/Tooltip';


const initialColumns = [
  { id: "packageCode", label: "Package Code", isSort: true, sortLabel: "asc" },
  { id: "packageName", label: "Package Name", isSort: true, sortLabel: "asc" },
  { id: "col3", label: "Description", isSort: true, sortLabel: "asc" },
  { id: "category", label: "Category", isSort: true, sortLabel: "asc" },
  { id: "subcategory", label: "Sub Category", isSort: true, sortLabel: "asc" },
  { id: "boqQty", label: "BOQ Qty", isSort: true, sortLabel: "asc" },
  { id: "createdAt", label: "Package Creation Date", isSort: true, sortLabel: "asc" },
  { id: "status", label: "Status", isSort: true, sortLabel: "asc" },
  { id: "department", label: "Department", isSort: true, sortLabel: "asc" },
  // { id: "dueDate", label: "Due Date", isSort: true, sortLabel: "asc" },
];

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const requestPayloadInitials = {
  pageNumber: 1,
  pageSize: 10,
  sortArray: [],
  searchCriteria: [],
};

function ProjectDetail() {
  const { id } = useParams();
  const [columns, setColumns] = useState(initialColumns);
  const [projectDetails, setProjectDetails] = useState({ packages: [] });
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [filterText, setFilterText] = useState("");
  const [projectDetailsPackageList, setProjectDetailsPackageList] = React.useState({
    totalPages: 0,
    currentPage: 1,
    totalItems: 0,
    packages: [],
  });

  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const [secPackagePermission, setSecPackagePermission] = useState({
    "create": false,
    "read": false,
    "update": false,
    "delete": false
  });
  const [secProjectPackagePermission, setProjectPackagePermission] = useState({
    "create": false,
    "read": false,
    "update": false,
    "delete": false
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedColumns = Array.from(columns);
    const [removed] = reorderedColumns.splice(result.source.index, 1);
    reorderedColumns.splice(result.destination.index, 0, removed);

    setColumns(reorderedColumns);
  };

  const [opencreatepackagelisting, setOpenCreatePackageListing] = useState(false);
  const [filterFormData, setFilterFormData] = useState("");
  // useEffect(() => {
  //   projectServices
  //     .getProjectDetails(id)
  //     .then((res) => {
  //       // throw errors
  //       if (res.data.success === true) {
  //         setProjectDetails(res.data.data);
  //       } else {
  //         setAlertComponent({
  //           open: true,
  //           type: "error",
  //           message: `No Data Found `,
  //         });
  //       }
  //     })
  //     .catch(function (error) {
  //       setAlertComponent({
  //         open: true,
  //         type: "error",
  //         message: `${error?.response?.data?.message}`,
  //       });
  //     })
  //     .finally((param) => {
  //       setIsLoading(false);
  //     });

    
  // }, []);
  
  useEffect(() => {
    let permissionObj = getSecPermission("PACKAGE_LISTING");
    let permissionObj1 = getSecPermission("CREATE_PACKAGE_PROJECT","PROJECT_DETAILS");
      setSecPackagePermission(permissionObj);
      setProjectPackagePermission(permissionObj1);
  }, []);

  // useEffect(() => {
  //   getProjectDetailsPackageList(requestPayload, filterText);
  // }, [requestPayload]);

  useEffect(() => {
    getProjectDetailsPackageList(requestPayload, filterText, filterFormData);
  }, [requestPayload, filterText]);
  const getProjectDetailsPackageList = (requestPayloadParam, filterTextParam, formData) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    const filteredFormData = formData ? Object.entries(formData)
      .filter(([key, value]) => value !== '')
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {}) : {};
    if (filteredFormData && Object.keys(filteredFormData).length > 0) {
      Object.entries(filteredFormData).forEach(([key, value]) => {
        param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      });
    }

    projectServices
      .getProjectDetailsPackageList(id, param)
      .then((res) => {
        // throw errors
        if (res.data.success === true) {
          setProjectDetailsPackageList(res?.data?.data);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);

    }, 800),
    []
  );

  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value);
    debouncedSearch(value);
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (!/[0-9a-zA-Z]/.test(e.key)) {
      e.preventDefault();
    }
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };

  const onFilterSubmit = () => {
    getProjectDetailsPackageList(requestPayload, filterText);
  };

  const onSortChange = (index, sortBy, sortOrder) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;
    columnsInit[index].sortLabel = newSortLael;
    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
  }

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayload(requestPayloadInit);
  }

  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
  }
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${day}-${month}-${year}`;
  };

  const handleResetFormSubmit = () => {
    getProjectDetailsPackageList(requestPayload, filterText, {});
  }
  const handleFilterFormSubmit = (formDataa) => {
    setFilterFormData(formDataa);
    const updatedPayload = {
      ...requestPayload,
      searchCriteria: formDataa,
    };
    setRequestPayload(updatedPayload);
    getProjectDetailsPackageList(updatedPayload, filterText, formDataa || '');
  };

  const [activeProjectFields, setactiveProjectFields] = useState([]);
  // useEffect(() => {
  //   getProjectFieldDetails();
  // }, []);

  const getProjectFieldDetails = () => {
    setIsLoading(true); 
    projectServices
      .getProjectFieldList('BIDDING','PROJECT')
      .then((res) => {
        // if (res.data.success === true) { 
        //   setactiveProjectFields(res.data?.data?.sections[0]?.fields);
        // } else {
        //   setAlertComponent({
        //     open: true,
        //     type: "error",
        //     message: `No Data Found `,
        //   });
        // }

        const fields = res?.data?.data?.sections?.[0]?.fields || [];
        if (fields.length > 0) {
          setactiveProjectFields(fields);  
        } else {
          setAlertComponent({
            open: true,
            type: "info",  
            message: "No Data Available",
          });
        }

      })
      .catch(function (error) {
        // setAlertComponent({
        //   open: true,
        //   type: "error",
        //   message: `${error?.response?.data?.message} `,
        // });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };  

  const getProjectDetails = () => {
    setIsLoading(true);
    projectServices
      .getProjectDetails(id)
      .then((res) => {
        if (res.data.success) {
          setProjectDetails(res.data.data || {});
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found`,
          });
        }
      })
      .catch((error) => {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message || "Error fetching details"}`,
        });
      })
      .finally(() => setIsLoading(false));
  };
  const [syncedData, setSyncedData] = useState([]);


  const syncData = () => {
  const synced = activeProjectFields.map((field) => { 
    const fieldValue =
      projectDetails[field.uniqueName] ||
      projectDetails?.additionalFields?.[field.uniqueName] ||
      "N/A"; 
    let displayValue = fieldValue;

    if (field.type === "Dropdown" && field.options?.length) {
      const matchedOption = field.options.find(
        (option) => option._id === fieldValue
      );
      displayValue = matchedOption ? matchedOption.optionName : "N/A";
    }

    return {
      ...field,
      value: displayValue, // Store the resolved name or fallback to the value
    };
  }); 
  setSyncedData(synced);
};

  useEffect(() => {
    getProjectFieldDetails();
    getProjectDetails();
  }, [id]);

  useEffect(() => {
    if (activeProjectFields.length && Object.keys(projectDetails).length) {
      syncData();
    }
  }, [activeProjectFields, projectDetails]); 

  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="search_filter_outerse ms-auto">
            <div className="search_main">
              <h5>Project Detail </h5>
            </div>
          </div> 
          <div class="listing_project_block_mainsection1">
                <div class="listing_project_block_2">
                    <div class="listing_project_block_3">
                      <p className="project_code_texts_creationlisbv">
                        <b>Project Name</b>
                      </p>
                      <p class="block_detail_listing">
                      <Tooltip title={projectDetails?.projectName || "N/A"}>
                                  {trimString(projectDetails?.projectName, 15 || "N/A")}
                                  </Tooltip></p>
                    </div>
                  </div>
                  {syncedData.map((field) => { 
                      if (field.value === "N/A") return null; 
                      return (
                        <div key={field.uniqueName} className="listing_project_block_2">
                          <div className="listing_project_block_3"> 
                            <p className="project_code_texts_creationlisbv">
                              <b>{field.name}</b>
                            </p> 
                            <p className="block_detail_listing">
                            <Tooltip title={field.type === "Date" ? formatDate(projectDetails.COD) : (field.value || "N/A"
                              )}>
                               {field.type === "Date" ? formatDate(projectDetails.COD) : (trimString(field.value, 20) || "N/A")}
                                  </Tooltip>
                            </p>
                          </div>
                        </div>
                      );
                    })}

            {/* <div class="listing_project_block_2">
              <div class="listing_project_block_3">
                <p className="project_code_texts_creationlisbv">
                  <b>Project Name</b>
                </p>
                <p class="block_detail_listing">{projectDetails?.projectName}</p>
              </div>
            </div>
            <div class="listing_project_block_2">
              <div class="listing_project_block_3">
                <p className="project_code_texts_creationlisbv">
                  <b>Project Code:</b>
                </p>
                <p class="block_detail_listing">{projectDetails?.projectCode}</p>
              </div>
            </div>
            <div class="listing_project_block_2">
              <div class="listing_project_block_3">
                <p className="project_code_texts_creationlisbv">
                  <b>Project Location:</b>
                </p>
                <p class="block_detail_listing">{projectDetails?.location}</p>
              </div>
            </div>
            <div class="listing_project_block_2">
              <div class="listing_project_block_3">
                <p className="project_code_texts_creationlisbv">
                  <b>No. of Packages:</b>
                </p>
                <p class="block_detail_listing">{projectDetailsPackageList?.totalItems}</p>
              </div>
            </div>
            <div class="listing_project_block_2">
              <div class="listing_project_block_3">
                <p className="project_code_texts_creationlisbv">
                  <b>Capacity:</b>
                </p>
                <p class="block_detail_listing">{projectDetails?.capacity}</p>
              </div>
            </div>
            <div class="listing_project_block_2">
              <div class="listing_project_block_3">
                <p className="project_code_texts_creationlisbv">
                  <b>COD:</b>
                </p>
                <p class="block_detail_listing">{formatDate(projectDetails.COD)}</p>
              </div>
            </div> */}
          </div>
          <div className="search_filter_outers ms-auto">
            <div className="search_main">
              <div id="custom-search-input">
                <div className="input-group col-md-12">
                  <input
                    type="text"
                    className="form-control input-lg"
                    placeholder="Search here"
                    fdprocessedid="8achb"
                    onChange={onFilterTextChange}
                    value={filterText}
                    onKeyPress={onKeyPressHandler}
                  />
                  <span className="input-group-btn">
                    <button
                      className="btn btn-info btn-lg"
                      type="button"
                      fdprocessedid="trsp06"
                    >
                      <span className="glyphicon glyphicon-search">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-search"
                          viewBox="0 0 16 16"
                        >
                          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                        </svg>
                      </span>
                    </button>
                  </span>
                </div>
              </div>
            </div>
            <div className="create_listing_project">
              {(secProjectPackagePermission?.create == true) && <div className="vendor_listing_lr_block_body">
                <button className="gate_btn_lr_creations">
                  <Link
                    style={{ color: "white", textDecoration: "none" }}
                    to={`/admin/Package-Creation-Form?p=${projectDetails?.projectCode}`}
                  >
                    <AddIcon />
                    Create Package
                  </Link>
                </button>
              </div>}

              <div className="row_filterrbtnvendor_box">
                <div className="lets_filter_vendorlist_body_detail">
                  <FilterAltIcon />
                  <Filter uniqueName="PROJECT_PACKAGES" formSubmitFunction={handleFilterFormSubmit} resetFilter={handleResetFormSubmit} />
                </div>
                <Backdrop
                  sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                  }}
                  open={isLoading}
                >
                  <CircularProgress color="inherit" />
                </Backdrop>
              </div>

            </div>
          </div>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable" direction="horizontal">
              {(provided) => (
                <div
                  className="listing_main"
                  style={{ overflowX: "scroll" }}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  <table>
                    <thead>
                      <tr>
                        {/* <th className="vendor_tabels">
                          <input type="checkbox" />
                        </th> */}
                        {columns.map((column, index) => (
                          <Draggable
                            key={column.id}
                            draggableId={column.id}
                            index={index}
                          >
                            {(provided) => (
                              <th
                                className="vendor_tabels"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                {column.label}
                                {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)}>
                                  <SwapVertIcon className="swap-sort-ico" />
                                </span>}
                              </th>
                            )}
                          </Draggable>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {projectDetailsPackageList?.packages.length < 1 && <>
                        <tr>
                          <td colSpan={10} className="text-center list-no-data">No Data Found</td>
                        </tr>
                      </>}

                      {projectDetailsPackageList?.packages.length > 0 && <>
                        {projectDetailsPackageList?.packages?.map((row, rowIndex) => (
                          <tr key={rowIndex} className="maine_tr_vendor">
                            {/* <td>
                              <input type="checkbox" />
                            </td> */}
                            {columns.map((column, index) => (<>
                              {(column.id === "packageCode") ? <td>
                                <Link
                                  className="solutions_block_body"
                                  style={{ textDecoration: "none" }}
                                  to={`/admin/Project-Manager-Package-Detail/${row?._id}`}
                                >
                                  {row[column.id]}
                                </Link>
                              </td> : column.id === "createdAt" ? (
                                <td> {formatDate(row[column.id])}</td>
                              ) :
                                <td key={index} >
                                  {row[column.id]}
                                </td>
                              }

                            </>
                            ))}
                          </tr>
                        ))}
                      </>}

                      {/* {projectDetailsPackageList?.packages?.map((row, rowIndex) => (
                        <tr key={rowIndex} className="maine_tr_vendor">
                          <td>
                            <input type="checkbox" />
                          </td>
                          {columns.map((column, index) => (
                            <td
                              key={index}
                              className={
                                index === 1 || index === 1 ? "block_solar" : ""
                              }
                            >
                              {row[column.id]}
                            </td>
                          ))}
                        </tr>
                      ))} */}
                    </tbody>
                  </table>
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>

          {projectDetailsPackageList?.packages.length > 0 && <>
            <div className="lets_pagination_package_listing_react">
              <div className="pagination_select_react_packagelr_detail">
                <select
                  className="form-select packagelrlisting from-hs"
                  onChange={onPageSizeChange}
                  value={requestPayload?.pageSize}
                >
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span className="react_text_showing">
                  {` Showing rows ${Number(projectDetailsPackageList?.pageSize) * Number(projectDetailsPackageList?.currentPage - 1) + 1} to ${Number(projectDetailsPackageList?.pageSize) * Number(projectDetailsPackageList?.currentPage - 1) + Number(projectDetailsPackageList?.packages.length)} of ${projectDetailsPackageList?.totalItems}`}
                </span>
              </div>
              <Stack spacing={2}>
                <Pagination
                  count={projectDetailsPackageList?.totalPages}
                  page={projectDetailsPackageList?.currentPage}
                  onChange={onPaginationChange}
                  renderItem={(item) => (<>
                    <PaginationItem
                      className="pagination_react_listings"
                      slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                      {...item}
                    />
                  </>
                  )}
                />
              </Stack>
            </div>
          </>}
          {/* ProjectManager Bidding Create Package  */}
          <Modal
            open={opencreatepackagelisting}
            onClose={() => setOpenCreatePackageListing(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Create Package
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenCreatePackageListing(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <from>
                  <div className="approvel_btn_successfully">
                    <p>
                      You don't have rights for this feature. Please coordinate
                      with Engineer/QA team.
                    </p>
                  </div>
                </from>
              </div>
            </Box>
          </Modal>
        </div>
      </div >

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />
      <Backdrop
        className="backdrop-index"
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default ProjectDetail;
